import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import DatetimePicker from 'ui-library/inputs/DatetimePicker';

import {DateInputProps, DatetimeInputProps} from './InputConstants';

type BaseDatetimeInputProps =
  // The fields narrowed here are either defaulted or explicitly passed by `DateInput` / `DatetimeInput`
  | (DatetimeInputProps & {
      autoFocus: boolean;
      hasButton: boolean;
      showTimeInput: true;
    })
  | (DateInputProps & {
      autoFocus: boolean;
      hasButton: boolean;
      validDatetimeInputFormats: Array<string>;
      datetimePresentationalFormat: string;
      showTimeInput: false;
    });

export function BaseDatetimeInput({...props}: BaseDatetimeInputProps): JSX.Element {
  return (
    <DatetimePicker
      {...props}
      datetimeInputClassName={classNames(
        Boolean(props.datePickerPopperContainerSelector) && css(styles.pickerDatetimeInputWithoutBorder)
      )}
      popperModifiers={{
        // TODO(BNCH-29431): parameterize these modifiers
        // when rendering in a notebook's structured table, the popper needs to be manually offset to be aligned with
        // the table cell's boundaries
        offset: {
          enabled: Boolean(props.datePickerPopperContainerSelector),
          offset: '-6px, 6px',
        },
        preventOverflow: {
          enabled: true,
          escapeWithReference: true,
          boundariesElement: 'viewport',
        },
      }}
      calendarClassName={props.wrapperClassName}
      showPopperArrow={false}
      disabled={props.isDisabled}
    />
  );
}

export function DateInput({
  autoFocus = false,
  hasButton = false,
  validDatetimeInputFormats = ['YYYY-MM-DD'],
  datetimePresentationalFormat = 'YYYY-MM-DD',
  ...props
}: DateInputProps): JSX.Element {
  return (
    <BaseDatetimeInput
      {...props}
      autoFocus={autoFocus}
      hasButton={hasButton}
      validDatetimeInputFormats={validDatetimeInputFormats}
      datetimePresentationalFormat={datetimePresentationalFormat}
      showTimeInput={false}
    />
  );
}

export default function DatetimeInput({
  autoFocus = false,
  hasButton = false,
  ...props
}: DatetimeInputProps): JSX.Element {
  return <BaseDatetimeInput {...props} autoFocus={autoFocus} hasButton={hasButton} showTimeInput={true} />;
}

const styles = StyleSheet.create({
  pickerDatetimeInputWithoutBorder: {
    border: 'none',
  },
});
